import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBvRl9YuJRarE3ZrxMSjQoJbeec6l1gsds",
  authDomain: "cubersden-2598b.firebaseapp.com",
  projectId: "cubersden-2598b",
  storageBucket: "cubersden-2598b.firebasestorage.app",
  messagingSenderId: "345581674988",
  appId: "1:345581674988:web:8ea92e7bfb04da593320c9",
  measurementId: "G-3KDCR8PTFR"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Initialize analytics only if supported
export const analytics = await isSupported().then(yes => yes ? getAnalytics(app) : null);

export default app; 